
export class ContactFormModel {
  constructor () {
    this.name = null
    this.email = null
    this.phoneNumber = null
    this.fiscalEntity = null
    this.street = null
    this.city = null
  }
}
